import { FETCH_PROPERTIES_STARTED, FETCH_PROPERTIES_SUCCEEDED, FETCH_PROPERTY_GROUPS_FAILED, FETCH_PROPERTY_GROUPS_STARTED, FETCH_PROPERTY_GROUPS_SUCCEEDED } from './ActionTypes';
import { fetchProperties as fetchPropertiesRequest, fetchPropertyGroups as fetchPropertyGroupsRequest } from '../api/propertiesApi';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
export function fetchProperties() {
  return dispatch => {
    dispatch({
      type: FETCH_PROPERTIES_STARTED
    });
    return fetchPropertiesRequest().then(data => {
      dispatch({
        type: FETCH_PROPERTIES_SUCCEEDED,
        payload: data
      });
    });
  };
}
export function fetchPropertyGroups() {
  return dispatch => {
    dispatch({
      type: FETCH_PROPERTY_GROUPS_STARTED
    });
    return fetchPropertyGroupsRequest().then(data => {
      dispatch({
        type: FETCH_PROPERTY_GROUPS_SUCCEEDED,
        payload: data
      });
    }).catch(error => {
      logRavenException(error, 'Failed to fetch property groups');
      dispatch({
        type: FETCH_PROPERTY_GROUPS_FAILED
      });
    });
  };
}